<div class="form-group">
    <label>{{label}}</label>
    <select class="custom-select" [ngClass]="size == '' ? '' : 'custom-select-'+ size" [id]="idForm"
        name="{{idForm}}" [formControl]="control" (change)="returnText($event)">
        <option *ngIf="default" [value]="defValue" selected>{{defText}}</option>
        <option *ngFor="let item of obj" [value]="item.id">
            {{item.descripcion}}</option>
    </select>
</div>